<template>  
    <div class="license-management" @click="handleClick">   
      <div class="input-group">
        <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span> 
        <input  
          v-model="searchQuery"  
          @input="handleSearch"  
          placeholder="搜索客户或设备"  
          class="search-input"  
        /> 
        <!-- 搜索栏最右边显示单独的过滤按钮 --> 
        <button class="filter-button" @click.stop="toggleFilter">  
          筛选
        </button> 
      </div>

      <!-- 显示过滤条件界面 -->  
      <div v-if="showFilter" ref="filterPopup" class="filter-popup" @click.stop>  
        <div class="popup-header">
          <h4 class="popup-title">筛选项</h4>  
          <button class="close-button" @click="showFilter = false">×</button>
        </div>

        <!-- 授权时间 -->
        <div class="filter-section">  
          <h5>授权状态</h5>  
          <div class='filter-options'>
            <button   
                  v-for="status in statusData"   
                  :key="status.objectid"   
                  :class="{selected: selectedStatusItem.includes(status.objectid) }"   
                  @click="toggleStatus(status.objectid)"  
                >  
                  {{ status.objectname }}  
                </button> 
          </div>
        </div>  
         
        <!-- 客户名称筛选 -->  
        <div class="filter-section">  
          <h5>客户名称</h5>  
          <div class="filter-options">  
            <button  
              v-for="client in customerData"  
              :key="client.customerid"  
              :class="{ selected: selectedClients.includes(client.customername) }"  
              @click="toggleClient(client.customername)"  
            >  
              {{ client.shortname }}  
            </button>  
          </div>  
        </div>    

        <!-- 产品名称筛选 -->  
        <div class="filter-section">  
          <h5>产品名称</h5>  
          <div class="filter-options">  
            <button  
              v-for="product in productData"  
              :key="product.productid"  
              :class="{ selected: selectedProducts.includes(product.productname) }"  
              @click="toggleProduct(product.productname)"  
            >  
              {{ product.productname }}  
            </button>  
          </div>  
        </div>  

        <button class="apply-button" @click="applyFilters">确定</button>  
      </div>
   
      <!-- 显示授权卡片列表 -->
      <div class="license-list" @scroll="handleScroll">  
        <div  
          class="license-card"  
          v-for="(license, index) in displayedLicenses"  
          :key="index"  
          @click="openAuthorizeModal(license)"
        >  
          <!-- 卡片左上角角标显示 -->
          <div class="badge" v-if="isExpiryDateApproaching(license.expiredate)">
             {{ getExpiryStatus(license.expiredate) }}
          </div>

          <!-- 卡片内容显示 -->
          <img v-if="license.imageurl" :src="license.imageurl" alt="" class="license-image" />  
          <div class="license-details">  
            <div class="customer-name">{{ license.customername }}</div>  
            <div class="device-info">  
              <span>设备名称: {{ license.productname }} </span>  
            </div>  
            <div class="device-info">  
              <span>机台标识: {{ license.shortname }}</span>  
            </div>  
            <div class="expiry-date" :class="{ 'highlight': isExpiryDateApproaching(license.expiredate) }">  
              授权截止日期: {{ formattedUTCdate(license.algorithmid, license.expiredate) }}  
            </div>  
          </div>  
        </div>  
      </div> 
      
      <!-- 点击卡片时的窗体显示,增加遮罩层显示 -->
      <div v-if="showModal" class="modal-overlay"></div> 
      <div v-if="showModal" class="modal" @click.stop>
        <div class="modal-header">
          <img v-if="selectedLicense.imageurl" :src="selectedLicense.imageurl" alt="" class="selectedlicense-image" />  
          <button class="close-button" @click="closeModal">
            <span class="icon">×</span>   <!-- 只显示关闭按钮 -->
          </button>  
        </div>

        <div class="modal-title">
          <div class="device-info-modal">
            <h2 class="device-name">{{ selectedLicense.productname + ' ' + selectedLicense.model + ' ' + selectedLicense.vertypename}}</h2>  
            <p class="customer-name">{{ '已授权 ' + selectedLicense.customername + ' 至 ' + selectedLicense.expiredate }}</p> 
          </div>
        </div>

        <div class="spacing"></div>

        <div class="modal-body">  
          <div class="filter-section">  
            <label for="locCode">序列号:</label>  
            <textarea id="locCode" v-model="selectedLicense.loccode" rows="3" class="wide-input" ></textarea>  
          </div>  
          
          <div class="filter-section">  
            <label for="regCode">注册码：</label>   
            <textarea id="regCode" v-model="selectedLicense.regcode" rows="4" class="wide-input" ></textarea>         
            <div class="regcode-options">
              <div class="algorithm-options">  
                <button   
                  v-for="algorithm in algorithmsData"   
                  :key="algorithm.objectid"   
                  :class="{'active': selectedLicense.algorithmid === algorithm.objectid}"   
                  @click="selectAlgorithm(algorithm.objectid)"  
                >  
                  {{ algorithm.objectname }}  
                </button>  
              </div> 
            </div>          
          </div> 
          <div class="filter-section">  
            <label for="activationDate">激活日期:</label>  
            <p id="activationDate">{{ formatLastLoginTime(selectedLicense.activedate) }}</p>  
          </div>           
        </div>  

        <div class="modal-footer">  
          <div class="button-container" >        
           <button class="save-button" @click="showAuthTime = true">获取授权码</button>
            <!-- 弹窗形式显示原生日期选择 -->  
            <van-popup v-model:show="showAuthTime" position="bottom" round>
              <!-- 统一操作按钮，模仿 Vant 原生样式 -->
              <div class="custom-toolbar">
                <span class="cancel" @click="showAuthTime = false">取消</span>
                <span class="title">选择日期</span>
                <span class="confirm" @click="confirmDateTime">确定</span>
              </div>

              <!-- 动态内容区域 -->
              <div class="datetime-picker-wrapper"> 
                <!-- 只显示日期控件 -->
                <div v-if="pickerType === 'date'">
                  <van-date-picker
                      v-model="selectedDateOnly"
                      type="date"
                      :model-value="defaultDate"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @change="selectedDateChange"
                      :show-toolbar="false"/> 
                </div>

                <!-- 同时显示日期和时间控件 -->
                <div v-else-if="pickerType === 'datetime'" class="datetime-group">      
                  <van-date-picker
                      v-model="selectedDateOnly"
                      type="date"
                      :model-value="defaultDate"
                      :min-date="minDate"
                      :max-date="maxDate"
                      :show-toolbar="false"
                      @change="selectedDateChange"
                      class="date-picker"/>

                  <van-time-picker
                      v-model="selectedTimeOnly"
                      type="time"
                      :model-value="defaultTime"
                      :show-toolbar="false"
                      @change="selectedTimeChange"
                      class="time-picker"
                      />
                </div>
              </div>                              
            </van-popup>

          </div>  
        </div> 
      </div>

      <div v-if="isLicensePage.valueOf" class="floating-buttons">
        <!-- 显示所有授权设备数量 -->
        <div class="device-count">
           授权设备数量：{{ cardData.length }} / {{ displayedLicenses.length }}
        </div>
        <button class="add-button" @click.stop="addNewClick">添加授权</button>
      </div>  

      <!-- 添加新授权 -->
      <div v-if="showAppendModal" class="modal-overlay" @click="closeAppendModal"></div>
      <div v-if="showAppendModal" class="modal" @click.stop>
        <!-- 头部 -->
        <div class="modal-header">
          <img v-if="state.newLicense.imageurl" :src="state.newLicense.imageurl" 
            class="selectedlicense-image" alt=""/>
          <button class="close-button" @click="closeAppendModal">
            <span class="icon">×</span>   <!-- 只显示关闭按钮 -->
          </button>    
        </div>

        <!-- 主体内容 -->
        <div class="modal-content">
          <!-- 第一行 -->
          <div class="license-input-group">
            <div class="input-item">
              <div class="label-wrapper">
                <label>客户名称</label><span class="must-input">*</span>
              </div>    
              <input 
                v-model="state.newLicense.customer.name"
                @focus="state.showPicker.customer = true"
                placeholder="请选择客户"
                readonly
              />
              <van-popup 
                v-model:show="state.showPicker.customer" 
                position="bottom"
                round
                :style="{ height: '40%' }">
                <van-picker
                  :columns="customerOptions"
                  @confirm="(val) => onPickerConfirm('customer', val)"
                  @cancel="closePicker('customer')"
                />
              </van-popup>
            </div>

            <div class="input-item">
              <div class="label-wrapper">
                <label>产品名称</label><span class="must-input">*</span>
              </div>  
              <input
                v-model="state.newLicense.product.name"
                @focus="state.showPicker.product = true"
                placeholder="请选择产品"
                readonly
              />
              <van-popup
                v-model:show="state.showPicker.product"
                position="bottom"
                round
                :style="{ height: '40%' }">
                <van-picker
                  :columns="productOptions"
                  @confirm="(val) => onPickerConfirm('product', val)"
                  @cancel="closePicker('product')"
                />
              </van-popup>
            </div>
          </div>

          <!-- 第二行 -->
          <div class="license-input-group">
            <div class="input-item">
              <div class="label-wrapper">
                <label>版本类型</label><span class="must-input">*</span>
              </div>  
              <input
                v-model="state.newLicense.vertype.name"
                @focus="state.showPicker.vertype = true"
                placeholder="请选择版本类型"
                readonly
              />
              <van-popup
                v-model:show="state.showPicker.vertype"
                position="bottom"
                round
                :style="{ height: '40%' }">
                <van-picker
                  :columns="versionOptions"
                  @confirm="(val) => onPickerConfirm('vertype', val)"
                  @cancel="closePicker('vertype')"
                />
              </van-popup>
            </div>

            <div class="input-item">
              <div class="label-wrapper">
                <label>算法类型</label><span class="must-input">*</span>
              </div>  
              <input
                v-model="state.newLicense.algorithm.name"
                @focus="state.showPicker.algorithm = true"
                placeholder="请选择算法类型"
                readonly
              />
              <van-popup
                v-model:show="state.showPicker.algorithm"
                position="bottom"
                round
                :style="{ height: '40%' }">
                <van-picker
                  :columns="algorithmOptions"
                  @confirm="(val) => onPickerConfirm('algorithm', val)"
                  @cancel="closePicker('algorithm')"
                />
              </van-popup>
            </div>
          </div>
        
          <!-- 独立输入项 -->
          <div class="single-input">
            <div class="label-wrapper">
                <label>机台标识</label><span class="must-input"></span>
              </div>  
            <input v-model="state.newLicense.shortname" placeholder="请输入机台标识区分设备，长度不超过10个字"/>
          </div>

          <div class="single-input">
            <div class="label-wrapper">
                <label>软件版本号</label><span class="must-input"></span>
              </div>  
            <input v-model="state.newLicense.version" placeholder="请输入软件版本号"/>
          </div>

          <div class="single-input">
            <div class="label-wrapper">
                <label>下位机描述</label><span class="must-input"></span>
              </div>  
            <textarea 
              v-model="state.newLicense.slavedesc"
              placeholder="请输入下位机描述信息"
              rows="3"
            ></textarea>
          </div>  
        </div>
        <div class="spacing"></div>  
        <!-- 保存数据 -->
        <button class="save-button" @click="saveNewLicense">保存</button>
      </div>

      <!-- 显示页面加载动画 -->
      <div v-if="issavingdata" class="loader-overlay">
        <div class="loader">  
            <svg class="spinner" viewBox="0 0 50 50">  
              <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />  
            </svg>  
            <p> 正在提交数据...</p>
        </div>  
      </div> 

    </div>  
  </template>  
  
  <script>  
  import { ref, computed, onMounted, getCurrentInstance, defineComponent, reactive } from 'vue';
  import { cardData as importedCardData, customerData, productData, algorithmsData, versionTypeData, statusData } from '@/utils/publicdata'; 
  import { formatLastLoginTime, getFormattedDate, getExpiryStatus, getExpiryStatusID, parseTableData } from '@/utils/dateFormatter';
  import axios from 'axios';

  export default defineComponent ({  
    beforeCreate() {

    },
    created() {
      // 刷新数据放在这里处理,create优先于OnMount执行
    },
    mounted() {

    },
    setup() {

      console.log('执行License的SetUp');

      const token = ref('');
      const userid = ref('');  
      const cardData = ref(importedCardData);   // 完整的卡片列表
      const searchQuery = ref('');          // 搜索查询
      const displayedLicenses = ref([]);    // 当前已显示的卡片列表
      const pageSize = ref(10);             // 每页显示的卡片数
      const currentPage = ref(1);           // 当前显示的页码
      const isLoading = ref(false);         // 是否正在加载数据 
      const showModal = ref(false);     
      const showAuthTime = ref(false);      // 显示日期选择控件   
      const issavingdata = ref(false);      // 显示提交数据时的遮幕 
      const pickerType = ref('date');       // 日期选择器类型
      const { proxy } = getCurrentInstance();  // 获取JSON配置文件

      const selectedDateOnly = ref(new Date());   // 选择的日期
      const selectedTimeOnly = ref('00:00');      // 选择的时间
      // 当前最小日期（默认25年01月01日）  
      const minDate = ref(new Date(2025, 0, 1))  
      // 计算最大日期 = 当前最小日期 + 120年  
      const maxDate = computed(() => {  
        const d = new Date(minDate.value);  
        d.setFullYear(d.getFullYear() + 120);  
        return d  
      })   

      const formattedUTCdate = (algorithmid=0, datetime) => {
        if (algorithmid === 1)
          return proxy.$dayjs.utc(datetime).format('YYYY-MM-DD 00:00:00')
        else
          return proxy.$dayjs.utc(datetime).format('YYYY-MM-DD HH:mm:ss') 
      };

      const defaultDate = ref([]);
      const defaultTime = ref([]);
      
      const selectedLicense = ref({         // 当前选中的卡片信息
        productname: '',  
        customername: '',  
        model: '',  
        shortname: '',  
        expiredate: '',  
        vertypename: '',  
        slavedesc: '',  
        version: '',
        loccode: '',  
        regcode: '',  
        activedate: '',  
        algorithmid: 1,    // 默认算法类型  
        id: 0,             // 对应的后台记录ID    
        imageurl: '',    
      }); 

      const state = reactive({
        // 各个选择器的数据源
        pickerData: {
          customer: [],    // 客户数据
          product: [],     // 产品数据
          vertype: [],     // 版本类型
          algorithm: [],   // 算法类型
        },
      
        newLicense: {         // 当前选中的卡片信息
          product: {
            id: 0,
            name: '',
          },  
          customer: {
            id: 0,
            name: '',
          },   
          shortname: '',    // 设备号-现场机台编号
          vertype: {
            id: 0,
            name: '',
          },  
          slavedesc: '',    // 下位机信息
          version: '',      // 现场软件版本号
          algorithm: {
            id: 0,
            name: '',
          },    // 默认算法类型  
          imageurl: {
            type: String,
            required: true,
          }},   
          
          // 各种选择器的弹窗显示状态
          showPicker: {
            customer: false,
            product: false,
            vertype: false,
            algorithm: false,
          }
        });

      // 获取vant日期
      function selectedDateChange(date) {
        const selectedValues = date.selectedValues || [];
        selectedDateOnly.value = selectedValues; 
      }
      // 获取vant时间
      function selectedTimeChange(time) {
        selectedTimeOnly.value = time.selectedValues;
      }

      async function confirmDateTime() {  
        showAuthTime.value = false   // 点击确定后关闭弹窗
        // 参数校验（增强健壮性）
        const { algorithmid } = selectedLicense.value;
        if (![1, 2].includes(algorithmid)) {
          throw new Error(`无效的算法类型: ${algorithmid}`);
        }
        // 调用API接口获取授权注册码 
        try {     
          // 处理获取到的日期时间
          let finalDateTime;
          const {year, month, day} = getFormattedDate(selectedDateOnly.value);
          const padZero = (num) => num.padStart(2, '0');
          finalDateTime = `${year}-${padZero(month)}-${padZero(day)}`;
          
          // 合并日期时间
          if (pickerType.value === 'datetime') 
          {
            let hours = '', minutes = '';
            // 判断日期控件返回值是数组还是字符
            if (Array.isArray(selectedTimeOnly.value))
            {
              // 如果是数组，则直接转换
              [hours, minutes] = selectedTimeOnly.value.map(String);
            } else
            {
              // 如果是字符串，则按照冒号拆分  
              [hours, minutes] = selectedTimeOnly.value.split(':');
            }
            finalDateTime += ` ${padZero(hours)}:${padZero(minutes)}:00`
          }

          issavingdata.value = true;
          // 延迟1秒
          await new Promise(resolve => setTimeout(resolve, 1000)); 

          const response = await getAuthCode(token.value, 
                                             userid.value, 
                                             finalDateTime);
          if (response.status ===0 )
          {  
            // 更新界面显示值
            selectedLicense.value.expiredate = finalDateTime;
            selectedLicense.value.regcode = response.data.regcode;
            selectedLicense.value.activedate = proxy.$dayjs.utc();
            // 保存成功后重新初始化日期显示  
            initPicker();  
          }
          else {
            errorMsg.value = response.message; // 显示错误信息 
            alert(errorMsg.value);
          }
        }
        catch(error){
          alert('授权码获取失败:' + error); 
        }  
        finally {
          issavingdata.value = false;
        }   
      } 
     
      // 过滤界面
      const showFilter = ref(false);        // 控制过滤界面显示 
      const selectedClients = ref([]);      // 选择的客户  
      const selectedProducts = ref([]);     // 选择的产品  
      const selectedStatusItem = ref([]);   // 选择的授权状态
      const filterPopup = ref(null);  

      // 添加授权
      const showAppendModal = ref(false);      // 控制显示添加授权界面 

      // 生成选择器选项的通用逻辑
      const generateOptions = (DataFunc) => {
        return computed(() => {
          const rawData = DataFunc();
          // 添加空值保护
          return (Array.isArray(rawData) ? rawData : []).map(item => ({
            ...item,
            text: item.objectname,  // 默认值保护
            value: item.objectid         // 默认ID保护
          }));
        });
      };

      // 客户选择器选项
      const customerOptions = computed(() => {
        return state.pickerData.customer.map(item => ({
          ...item,
          text: item.customername,
          value: item.customerid
        }));
      });
      
      // 产品选择器选项
      const productOptions = computed(() => {
        return state.pickerData.product.map(item => ({
          ...item,
          text: item.productname,
          value: item.productid
        }));
      });

      // 版本选择器选项
      const versionOptions = generateOptions(() => state.pickerData.vertype);
      // 算法选择器选项
      const algorithmOptions = generateOptions(() => state.pickerData.algorithm);
     
      // 通用确认选择方法
      const onPickerConfirm = (type, value) => {
        if (type === 'customer')
        {
          state.newLicense[type].id = value.selectedOptions[0].customerid;  // 更新表单字段
          state.newLicense[type].name = value.selectedOptions[0].customername;  // 更新表单字段
        } else 
        if (type === 'product')
        {
          state.newLicense[type].id = value.selectedOptions[0].productid;    
          state.newLicense[type].name = value.selectedOptions[0].productname;  
        } else
        {
          state.newLicense[type].id = value.selectedOptions[0].objectid;      // 更新通用表单字段
          state.newLicense[type].name = value.selectedOptions[0].objectname;  // 更新通用表单字段
        }
       
        state.showPicker[type] = false; // 关闭弹窗
      };

      // 添加授权-关闭弹窗方法
      const closePicker = (type) => {
        state.showPicker[type] = false;
      };

      const loadCustomerData = () => {
        let data;
        data = customerData.value;
        return data;
      };

      const loadProductData = () => {
        let data;
        data = productData.value;
        return data;
      }

      const loadVersionData = () => {
        let data;
        data = versionTypeData.value;
        return data;
      }

      const loadAlgorithmData = () => {
        let data;
        data = algorithmsData.value;
        return data;
      }

      const errorMsg = ref('');  
      /* 保存添加授权信息 */
      const saveNewLicense = async() => {  
        errorMsg.value = '';       
        // 参数校验（增强健壮性）
        if (!(state.newLicense.customer?.name ?? '').trim()) {
          errorMsg.value = '客户名称不能为空！';
          alert(errorMsg.value);
          return;
        }
   
        if (!(state.newLicense.product?.name ?? '').trim()) {
          errorMsg.value = '产品名称不能为空！';
          alert(errorMsg.value);
          return;
        }

        if (!(state.newLicense.vertype?.name ?? '').trim()) {
          errorMsg.value = '版本类型不能为空！';
          alert(errorMsg.value);
          return;
        }

        if (![1, 2].includes(state.newLicense.algorithm?.id)) {
          errorMsg.value = `无效的算法类型: ${state.newLicense.algorithm.id}`;
          alert(errorMsg.value);
          return;
        }   
           
        // 调用API接口获取授权注册码 
        try {     
          issavingdata.value = true;
          const response = await saveNewLicenseData(token.value, 
                                                    userid.value);
          if (response.status ===0 )
          {             
            alert('数据保存成功！');
            await refreshLicenseData(); 
            await loadLicenses();
            // 更新界面显示值
            showAppendModal.value = false;   // 点击确定后关闭弹窗          
          }
          else {
            errorMsg.value = response.message; // 显示错误信息 
            alert(errorMsg.value);
          }
        }
        catch(error){
          alert('保存授权失败:' + error); 
        }  
        finally {
          issavingdata.value = false;
        }  
      }

      const saveNewLicenseData = async(token, userid) => {   
        try {
          // 调用API接口获取授权码
          const response = await axios.post(proxy.$config.API_BASE_URL + `/rest/appendauthinfo`, {         
            token,
            userid,
            customerid: state.newLicense.customer.id,   
            productid: state.newLicense.product.id,
            vertypeid: state.newLicense.vertype.id, 
            algorithmid: state.newLicense.algorithm.id,
            version: state.newLicense.version,
            shortname: state.newLicense.shortname,
            slavedesc: state.newLicense.slavedesc,
          },
          {
            headers: {  
              'Content-Type': 'application/json'  
            }
          });
          return {  
            status: response.data.status || 0 ,    // 若服务端返回则取服务端的返回状态
            message: response.data.message,
            data: response.data   // 后端返回的数据  
          };        
        } catch (error) {
            let errorMessage = '登录请求失败，请重试！';  // 默认错误消息  
            // 检查 error 对象  
            if (error.response) { // 请求已发出且服务器响应了  
              errorMessage = error.response.data?.message || errorMessage; // 尝试获取后端返回的错误消息  
            } 
            else 
            if (error.request) { // 请求已发出但没有响应  
              errorMessage = '服务器没有响应，请检查您的网络连接。';  
            } 
            else { // 触发了其他错误  
              errorMessage = error.message; // 使用 Axios 返回的原始错误消息  
            }  
            return {  
              status: 1,    // 返回异常时状态标志1
              message: errorMessage   // 返回API调用异常的错误信息 
            }; 
        }
      }

      // 授权界面
      const isGettingAuthCode = ref(false);    // 用于控制生成授权码按钮的操作状态

      const computedImageUrl = computed(() => {
        if (!displayedLicenses.value.imageurl) {
          return null;   //如果不是图片路径则返回null,不显示图片
        }
        try {
          return require(`${displayedLicenses.value.imageurl}`);
        } catch (error) {
          console.error("图片加载失败：", error);
          return null;
        }  
      });

      const loadLicenses = async() => {
        if (isLoading.value) return;  //防止重复加载
        isLoading.value = true;
  
        const start = (currentPage.value - 1) * pageSize.value;
        const end = start + pageSize.value;
        const filteredLicenses = filterLicenses.value.slice(start, end);

        // 追加新数据
        displayedLicenses.value.push(...filteredLicenses);

        // 确保数据存在
        if (filterLicenses.value.length > 0) {
          currentPage.value++;
        }
        isLoading.value = false;  // 加载完数据后复位
      };

      const applyFilters = () => {   
        showFilter.value = false; // 关闭过滤界面  
        handleSearch();
      };  

      const toggleFilter = () => {  
        showFilter.value = !showFilter.value; // 切换过滤界面显示状态  
      };  

      const addNewClick = () => {
        showAppendModal.value = !showAppendModal.value;  //切换添加授权窗体显示状态
      }

      const toggleClient = (clientname) => {  
        const index = selectedClients.value.indexOf(clientname);  
        if (index === -1) {  
          selectedClients.value.push(clientname); // 添加选项  
        } else {  
          selectedClients.value.splice(index, 1); // 移除选项  
        }  
      };  

      const toggleProduct = (productname) => {  
        const index = selectedProducts.value.indexOf(productname);  
        if (index === -1) {  
          selectedProducts.value.push(productname); // 添加选项  
        } else {  
          selectedProducts.value.splice(index, 1); // 移除选项  
        }  
      };  

      const toggleStatus = (statusid) => {
        const index = selectedStatusItem.value.indexOf(statusid);
        if (index === -1) {
          selectedStatusItem.value.push(statusid); // 添加选项
        } else {
          selectedStatusItem.value.splice(index, 1);   // 移除选项
        }
      }

      const filterLicenses = computed(() => {  
        let filtered = cardData.value;  
        
        // 根据客户过滤
        if (selectedClients.value.length) {  
          filtered = filtered.filter(license => selectedClients.value.includes(license.customername));  
        }  
        // 根据产品过滤
        if (selectedProducts.value.length) {  
          filtered = filtered.filter(license => selectedProducts.value.includes(license.productname));  
        }  
        // 根据授权状态过滤
        if (selectedStatusItem.value.length) {
          filtered = filtered.filter(license => selectedStatusItem.value.includes(getExpiryStatusID(license.expiredate)));
        }
        // 根据用户输入条件过滤
        if (searchQuery.value) {  
          const searchLower = searchQuery.value.toLowerCase();  
          filtered = filtered.filter((license) => {  
            return (  
              (license.customername && license.customername.toLowerCase().includes(searchLower)) ||  
              (license.productname && license.productname.toLowerCase().includes(searchLower)) ||  
              (license.model && license.model.toLowerCase().includes(searchLower))  
            );  
          });  
        }  
        return filtered;  
      });  
      
      // 搜索卡片信息的方法处理
      const handleSearch = () => {
        showFilter.value = false;
        currentPage.value = 1;   // 重置页码
        displayedLicenses.value = [];  // 清空显示的数据
        loadLicenses();
      };
      
      // 用户点击事件响应
      const handleClick = (event) => {
        // 如果点击的是搜索输入框，处理输入内容响应  
        if (event.target.matches('.search-input')) {  
          handleSearch(); 
          return;
        } else if (
            showFilter.value && 
            filterPopup.value &&
            event.target !== filterPopup.value &&
            !filterPopup.value.contains(event.target)
          ) {  
        // 如果点击的不是 `filter-popup` 的内部区域，则关闭弹窗  
            showFilter.value = false; 
          }
      };  

      /* 监听搜索查询变化, 暂时先移除该方法，如果后续需要在搜索时调用API处理，再考虑watch方法 
      watch(searchQuery, () => {  
        handleSearch(); 
      }); */

      const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        // 判断是否滚动到底部
        if (scrollTop + clientHeight >= scrollHeight - 5) {
          loadLicenses();    // 底部加载更多
        }
      };

      const isExpiryDateApproaching = (expiryDate) => {  
        const today = proxy.$dayjs.utc();  
        const expiry =proxy.$dayjs.utc(expiryDate);  
        const diffTime = expiry - today;  
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));  
        return diffDays <= 30; // 如果距离到期日期小于或等于30天，返回true  
      };

      const selectAlgorithm = (selectedAlgorithmid) => {  
        selectedLicense.value.algorithmid = selectedAlgorithmid;  
        if (selectedLicense.value.algorithmid === 1)
        {
          pickerType.value = 'date'
        }
        else
        if (selectedLicense.value.algorithmid === 2)
        {
          pickerType.value = 'datetime'
        }
      }; 

      const openAuthorizeModal = (license) => {
        selectedLicense.value = license;
        showModal.value = true;
        selectAlgorithm(selectedLicense.value.algorithmid);
        // 获取时间和日期默认显示值
        initPicker();
        document.body.style.overflow = 'hidden';  // 禁用主窗体滚动
      };

      // 到期时间解析处理（重点默认值处理，防止vant控件异常）
      const parseDateTime = (expiredate) => {
        // 1. 空值兜底处理
        if (!expiredate) {
          const now = new Date();
          return {
            date: [
              now.getFullYear().toString(),
              String(now.getMonth() + 1).padStart(2, '0'),
              String(now.getDate()).padStart(2, '0')
            ],
            time: ['00', '00']
          };
        }

        // 2. 拆分处理
        try {
          // 2.1 日期部分处理
          const [datePart = '', timePart = ''] = expiredate.split(' ');
          const dateArray = datePart.split('-');
          // 日期兜底（年、月、日）
          const [year = new Date().getFullYear().toString()] = dateArray;
          const month = dateArray[1] ? String(parseInt(dateArray[1])).padStart(2, '0') : '01';
          const day = dateArray[2] ? String(parseInt(dateArray[2])).padStart(2, '0') : '01';

          // 2.2 时间部分处理
          const timeArray = timePart.split(':');
          const hours = timeArray[0] ? String(parseInt(timeArray[0])).padStart(2, '0') : '00';
          const minutes = timeArray[1] ? String(parseInt(timeArray[1])).padStart(2, '0') : '00';

          return {
            date: [year, month, day],
            time: [hours, minutes]
          };
        } catch {
          // 3. 解析失败兜底
          return {
            date: ['2025', '01', '01'],
            time: ['00', '00']
          };
        }
      };

      // 根据到期日期解析并获取默认显示值
      const dateTime = computed(() => {
        return parseDateTime(selectedLicense.value?.expiredate);
      });

      // 初始化日期控件显示
      const initPicker = () => {
          // 根据到期日期解析并获取默认显示值
          const { date: aDate, time: aTime } = dateTime.value;
          defaultDate.value = aDate;
          defaultTime.value = aTime;
        };

      // 使用钩子函数获取全局变量 
      onMounted(async () => {  
          // 从 localStorage 获取用户信息  
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}'); 
          token.value = userInfo.token || '';
          userid.value = userInfo.userid || -1; 

          // 从 localStorage 重新获取基础数据
          const customerInfo = JSON.parse(localStorage.getItem('customerInfo') || '[]');
          customerData.value = customerInfo;

          const productInfo = JSON.parse(localStorage.getItem('productInfo') || '[]');
          productData.value = productInfo;

          const algorithmsInfo = JSON.parse(localStorage.getItem('algorithmsInfo') || '[]');
          algorithmsData.value = algorithmsInfo;

          const versionTypeInfo = JSON.parse(localStorage.getItem('versionTypeInfo') || '[]');
          versionTypeData.value = versionTypeInfo;

          const statusInfo = JSON.parse(localStorage.getItem('statusInfo') || '[]');
          statusData.value = statusInfo;

          // 调用接口重新获取卡片数据
          await refreshLicenseData(); 
          await loadLicenses();

          // 刷新VANT选择框数据
          state.pickerData.customer = await loadCustomerData();
          state.pickerData.product = await loadProductData();
          state.pickerData.vertype = await loadVersionData();
          state.pickerData.algorithm = await loadAlgorithmData();  

        }); 

      // 获取授权码
      const getAuthCode = async(token, userid, authdate) => {
        if (!selectedLicense.value.loccode) {
          errorMsg.value = '序列号为空！';
        } else {
          if (isGettingAuthCode.value) return;   // 若正在获取则返回

          isGettingAuthCode.value = true;
          try {
            // 调用API接口获取授权码
            const response = await axios.post(proxy.$config.API_BASE_URL + `/rest/getauthcode`, {         
              token,
              userid,
              authid: selectedLicense.value.id,          // 用于定位授权记录
              loccode: selectedLicense.value.loccode,    // 序列号
              algorithmid: selectedLicense.value.algorithmid,  // 申请使用的算法ID
              authdate,  // 授权日期
              querymethod: "getauthcode"
            },
            {
              headers: {  
                'Content-Type': 'application/json'  
              }
            });
            return {  
              status: response.data.status || 0 ,    // 若服务端返回则取服务端的返回状态
              message: response.data.message,
              data: response.data   // 后端返回的数据  
            };       
         
          } catch (error) {
              let errorMessage = '登录请求失败，请重试！';  // 默认错误消息  

              // 检查 error 对象  
              if (error.response) { // 请求已发出且服务器响应了  
                errorMessage = error.response.data?.message || errorMessage; // 尝试获取后端返回的错误消息  
              } 
              else 
              if (error.request) { // 请求已发出但没有响应  
                errorMessage = '服务器没有响应，请检查您的网络连接。';  
              } 
              else { // 触发了其他错误  
                errorMessage = error.message; // 使用 Axios 返回的原始错误消息  
              }  
              return {  
                status: 1,    // 返回异常时状态标志1
                message: errorMessage   // 返回API调用异常的错误信息 
              }; 
          }
          finally {
            isGettingAuthCode.value = false;
          }
        }   
      };  

      const closeModal = () => {
        showModal.value = false;
        selectedLicense.value = {};
        document.body.style.overflow = '';   // 恢复主窗体的滚动
      }; 

      const closeAppendModal = () => {
        showAppendModal.value = false;
        selectedLicense.value = {};
        document.body.style.overflow = '';   // 恢复主窗体的滚动
      }

      // 确定处于授权页面
      const isLicensePage = computed(() => {
        try {
          const parentContext = getCurrentInstance()?.parent?.exposed;
          return parentContext ? parentContext.currentModule.value === 'license' : false;
        } catch (error) {
          return false;
        }
      });

      const refreshLicenseData = async () => {
        // 加载卡片信息
        const cardsResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {  
            token: token.value,
            querymethod: 'getauthorizeinfo'
        },
        {
          headers: {  
          'Content-Type': 'application/json'  
          }
        });      
        cardData.value = parseTableData(cardsResponse.data);                 // 授权列表   
      }      
      
      return {
        token,
        userid,

        cardData,
        customerData,
        productData,
        algorithmsData,
        versionTypeData,
        statusData,

        searchQuery,
        displayedLicenses,
        pageSize,
        currentPage,
        showModal,
        showAppendModal,
        selectedLicense,
        selectedClients,
        selectedProducts,
        selectedStatusItem,
        isLicensePage,
        showFilter,
        filterPopup,
        pickerType,
        maxDate,
        defaultDate,
        defaultTime,
       
        state,
        customerOptions,
        productOptions,
        versionOptions,
        algorithmOptions,
       

        formatLastLoginTime,
        onPickerConfirm,
        closePicker,
        getExpiryStatus,
        loadLicenses,
        handleSearch,
        handleScroll,
        isExpiryDateApproaching,
        saveNewLicense,
 
        openAuthorizeModal,
        closeModal,
        closeAppendModal,
        computedImageUrl,
        showAuthTime, 

        /* 过滤弹窗的方法 */
        applyFilters,
        toggleFilter,
        addNewClick,
        toggleClient,
        toggleProduct,
        toggleStatus,
        handleClick,
        
        /* 授权弹窗的方法 */
        selectAlgorithm,
        confirmDateTime,
        selectedDateChange,
        selectedTimeChange,
        formattedUTCdate,
        refreshLicenseData,
      }; 
    },
  });
  </script>  
  
  <style scoped>  
  .license-management {  
    margin-top: 10px;  
  }  
  
  /* 主界面授权列表样式 */
  .license-list {  
    display: flex;  
    flex-direction: column; 
    overflow-y: auto; /* 允许内容滚动 */  
    max-height: 500px; /* 限制高度以便出现滚动条 */  
  }  

  .license-card {  
    position: relative; /* 使角标能够定位 */  
    display: flex;  
    align-items: center;  
    padding: 10px;  
    margin-bottom: 10px;    
    border-radius: 4px;  
    background-color: white;  
    cursor: pointer; /* 提示可点击 */ 
  }

  .badge {  
    position: absolute;  
    top: 10px;  
    left: 10px;  
    background-color: red;  
    color: white;  
    padding: 5px;  
    border-radius: 3px;  
    font-size: 12px;  
  }  

  .license-image {  
    width: 100px;  
    height: 100px;  
    margin-right: 10px; 
    margin-left: 10px;
    border-radius: 8px;
  }  

  .license-details {  
    flex-grow: 1;  
  }  

  .customer-name {  
    font-weight: bold;  
    font-size: 12px; 
    text-align: left;
  }  

  .device-info {  
    margin: 5px 0;  
    font-size: 12px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }  

  .expiry-date {  
    color: #666;  
    font-size: 12px;
    text-align: left;
  }  

  .expiry-date.highlight {  
    color: red; /* 突出显示即将到期的日期 */  
  } 

  /* 搜索输入框样式 */
  .input-group {  
    display: flex; 
    align-items: center;
    position: relative;  
    margin-bottom: 20px;  
    overflow: hidden;         /* 防止内容超出输入范围 */
  }  

  .input-group .icon {  
    position: absolute;  
    left: 10px;  
    top: 50%;  
    transform: translateY(-50%);  /* 垂直居中 */
    color: #888;      
  }  

  .input-group .search-input {  
    padding: 10px 10px 10px 40px;  
    width: 100%;  
    border: 1px solid #ccc;  
    border-radius: 4px;  
    box-sizing: border-box; /* 确保包括内边距和边框在内 */ 
  }  

  .input-group .filter-button { 
    position: absolute;
    right: 4px;
    background: #ff6a00f5;   
    border: none;  
    cursor: pointer;  
    color: white;
    border-radius: 4px;   
    padding: 5px 20px 5px 20px;
    box-sizing: border-box;
  } 

  /* 过滤下拉弹窗样式 */
  .filter-popup {  
    position: relative;  
    background: white;  
    border: 1px solid #ccc;  
    border-radius: 5px;  
    padding: 0px;   
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);  
    z-index: 1000;  
    box-sizing: border-box;
  }  

  .popup-header {
    display: flex;  
    justify-content: space-between;  
    align-items: center; /* 垂直居中对齐 */  
    background-color: #f0f0f0; /* 浅灰色 */  
    border-top-left-radius: 5px; /* 设置左上圆角 */  
    border-top-right-radius: 5px; /* 设置右上圆角 */  
    padding: 10px 10px; /* 上下10像素，左右10像素的内边距 */  
    width: 100%; /* 确保填满整个宽度 */  
    box-sizing: border-box; /* 包含内边距和边框在宽度计算内 */ ;  
  }

  .popup-title {
    font-size: 14px;   
    color: #333;
    margin: 0; /* 清除默认边距 */   
    flex-grow: 1; /* 确保标题占据可用空间 */ 
  }

  .filter-section {  
    margin-bottom: 15px;  
    text-align: left;
    padding: 0px 20px;
  }  

  .filter-section h4 {  
    margin-bottom: 10px;    
  }  

  .filter-options {  
    display: flex;  
    flex-wrap: wrap;  
    font-size: 12px;
  } 

  .filter-options button {  
    background: #f0f0f0;  
    border: none;  
    border-radius: 4px;  
    padding: 8px 12px;  
    margin: 5px;  
    cursor: pointer;  
    transition: background 0.3s;  
    color: #333
  }  

  .filter-options button.selected {  
    background: #ff9500f5;  
    color: white;    
  } 

  .apply-button {  
    margin: 20px 20px 10px; /* 上下增加边距，左右与上面内容对齐 */  
    padding: 10px; /* 上下左右均匀内边距 */  
    border: none;  
    border-radius: 4px;  
    cursor: pointer;  
    background-color: #ff6200; /* 确定按钮的颜色 */  
    color: white;  
    text-align: center; /* 居中文本 */  
    width: calc(100% - 40px); /* 宽度撑满，减去左右的边距 */  
  }  

  .close-button {  
    position: absolute;
    right: 20px;
    border: none;  
    background: none;  
    cursor: pointer;  
    font-size: 30px; /* 控制叉叉的字体大小 */  
    padding: 0; /* 清除内边距 */  
    color: #333;
  }  

  /* 主界面下方浮动按钮样式 */ 
  .floating-buttons {  
    position: fixed;  
    bottom: 0px;  
    left: 0;
    right: 0;   
    display: flex;  
    align-items: center;   /* 垂直对齐 */  
    justify-content: space-between;  /* 使元素之间的空间合理分配 */
    padding: 5px 20px;     /* 左右内边距 */
    box-shadow: 0 2px 12px rgba(0,0,0,0.6); 
    border: 1px solid #ebeef5;  
  }  

  .add-button {  
    padding: 8px 30px;  
    background-color: #007bff;  
    color: white;  
    border: none;  
    border-radius: 5px;  
    cursor: pointer;  
  }  

  .device-count {  
    font-weight: bold;
    font-size: 12px;
  }  

  /* 点击卡片的弹窗样式 */  
  .modal-overlay {    /* 遮罩层样式 */  
    position: fixed;  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    background-color: rgba(0, 0, 0, 0.5);  
    z-index: 100; /* 确保遮罩层处于最高层 */  
  } 

  .modal {  
    position: fixed;  
    bottom: 0;
    left: 0; 
    right: 0;
    background-color: rgba(255, 255, 255, 0.95); 
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);  
    z-index: 101;  
    padding: 0px;  
    width: 100%; /* 使用百分比宽度，适合手机 */  
    overflow-y: auto; /* 允许纵向滚动 */ 
    }  
 
  .modal-header {  
    display: flex;  
    justify-content: flex-start;  
    align-items: flex-start;  
    background-color: #f0f0f0;  
    border-top-left-radius: 8px;  
    border-top-right-radius: 8px;  
    padding: 20px;  
    width: 100%; 
    box-sizing: border-box; 
    height: auto;
    position: relative;  
  }  

  .selectedlicense-image {  
    width: 100%; /* 图片宽度填充 */  
    height: 150px; /* 定义图片高度 */  
    object-fit: cover; /* 保持图片比例 */  
    border-radius: 8px 8px 0 0; /* 图片顶部圆角 */ 
  }   

  .modal-title {  
    display: flex;  
    justify-content: space-between;  
    align-items: left;  
    padding: 20px 0px 0px 20px;
  }  

  .device-name {  
    text-align: left;   /* 从左边开始显示 */
    font-size: 18px;    /* 稍大字体 */  
    margin: 0;  
  }  

  .spacing {  
    height: 5px; /* 中间空出5px距离 */ 
    background-color: #f0f0f0;  
  }  

  .modal-body {  
    margin-top: 10px;  
    font-size: 12px;
  }  

  .form-group {  
    margin-bottom: 15px;  
  }  

  .filter-section label {  
    font-weight: bold;  
    display: block; /* 让标签独立成行 */  
    margin-bottom: 5px; /* 标签与内容之间的间距 */  
  }  

  .wide-input {  
    width: 100%; /* 占满可用宽度 */  
    height: auto; /* 高度根据行数调整 */  
    min-height: 60px; /* 设置最小高度 */    
    padding: 10px; /* 内边距设置 */  
    border-radius: 4px; /* 圆角边框 */  
    border: 1px solid #ccc; /* 边框样式 */  
    box-sizing: border-box; /* 处理内边距和边框 */  
    resize: vertical; /* 允许用户上下调整高度 */  
    background-color: #f9f9f9; /* 只读文本框背景颜色可以调整 */  
    color: #333; /* 文字颜色 */  
    cursor: not-allowed; /* 鼠标样式改变为禁用状态 */  
  }  

  .wide-input[readonly] {  
    background-color: #f0f0f0; /* 更加明显的只读状态背景颜色 */  
    color: #666; /* 只读状态文字颜色 */  
  }  

  .algorithm-options {  
    display: flex; /* 使用弹性布局 */  
    gap: 10px; /* 按钮间隔 */  
    margin-top: 10px; /* 上间距 */  
  }  

  .algorithm-options button {  
    padding: 5px 20px; /* 按钮内边距 */  
    border: none; /* 取消边框 */  
    border-radius: 4px; /* 圆角 */  
    background-color: #f0f0f0; /* 默认背景色 */  
    cursor: pointer; /* 鼠标指针样式 */  
    transition: background-color 0.3s; /* 动画效果 */
  }  

  .algorithm-options button.active {  
    background-color: #007bff; /* 选中状态的背景色 */  
    color: white; /* 选中状态的字体颜色 */  
  }   

  .modal-footer {  
    gap: 10px;
    margin-top: 20px;  
    margin-bottom: 20px;
    align-items: center;   /* 垂直对齐 */  
    justify-content: flex-end;  /* 使元素之间的空间合理分配 */
    padding: 0px 20px;     /* 左右内边距 */
  }  

  .button-container {  
    display: flex; /* 使用弹性布局来排列按钮 */  
    gap: 10px; /* 按钮间隔 */  
    justify-content: space-between;
  }  

  .save-button {  
    flex: 1;
    padding: 10px; /* 按钮内边距 */  
    border: none; /* 取消边框 */  
    border-radius: 4px; /* 角落圆润 */  
    cursor: pointer; /* 加入手指指针效果 */  
    text-align: center; /* 居中文本 */  
    background-color: #007bff; /* 获取授权码按钮背景颜色 */  
    color: white; /* 获取授权码按钮文本颜色 */ 
    width: calc(100%); /* 宽度撑满，减去左右的边距 */  
  } 

  /* 遮幕显示 */
  .loader-overlay {  
    position: fixed; /* 固定的定位 */  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    background-color: rgba(0, 0, 0, 0.5); /* 半透明黑幕 */  
    display: flex;  
    justify-content: center; /* 水平居中 */  
    align-items: center; /* 垂直居中 */  
    z-index: 9999; /* 确保在最上层 */  
  }  

  .loader {  
    display: flex;  
    flex-direction: column;  
    align-items: center;  
    font-size: 12px;
    color: #ccc;
  }  

  .spinner {  
    animation: rotate 2s linear infinite;  
    width: 40px;  
    height: 40px;  
  } 

  .path {  
    stroke: #007bff;  
    animation: dash 1.5s ease-in-out infinite;  
  }  

  /* vant日期控件日期和时间选择器显示 */
  .datetime-picker-wrapper {
    padding: 16px;
  }

  /* 控制选择器宽度占比 */
  .picker-group {
    display: flex;
    gap: 12px;
    width: 100%; 
  }

  .datetime-group {
    display: flex;
    gap: 8px;
    padding: 8px 16px 0;
    height: 250px;
  }

  /* 强制双列等宽显示日期和时间控件 */
  .date-picker,
  .time-picker { 
    flex: 1;
    min-width: calc(50% - 6px);
  }

  /* 覆盖Vant的默认样式 */
  .van-picker {
    width: 100% !important;
  }

  /* 复刻 Vant 原生工具栏样式 */
  .custom-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 20px;
    margin-bottom: 0;
    border-bottom: 0px solid #f0f0f0;
  }

  /* 标题居中显示 */
  .custom-toolbar .title {
    flex:1;
    text-align: center;
    font-size: 16px;
    color: #323233;
  }

  /* 取消按钮样式 */
  .cancel {
    color: #969799;
    cursor: pointer;
    padding: 8px 16px;
  }

  /* 确定按钮样式 */
  .confirm {
    color: var(--van-primary-color);
    cursor: pointer;
    padding: 8px 16px;
  }

  /* 按钮点击反馈效果 */
  .cancel:active,
  .confirm:active {
    opacity: 0.6;
  }

  /* 添加授权样式 */
/* 输入区域 */
.modal-content {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.license-input-group {
  display: grid;
}

.input-item, .single-input {
  flex: 1;
  display: flex;
  min-width: 200px;    /* 输入框最小宽度 */
  align-items: center;
  padding: 5px 20px;
  box-sizing: border-box; /* 确保包括内边距和边框在内 */ 
}

.label-wrapper {
  flex: 0 0 80px; /* 固定标签宽度 */
  white-space: nowrap; /* 防止文字换行 */
  text-align: left;
}

.must-input {
  color: red;
  margin-left: 4px; /* 星号与文字的间距 */
  font-weight: bold; /* 可选：加粗星号 */
}

input, textarea {
  width: 100%;
  padding: 12px;                 /* 输入框高度 */
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transition: border-color 0.3s;
}

input:focus, textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

textarea {
  resize: vertical;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .input-group {
    grid-template-columns: 1fr;
  }
  
  .modal {
    width: 95%;
    padding: 15px;
  }
}  


  </style>